export interface IPostgresTrigger {
	triggerName: string;
	functionName: string;
	channelName: string;
	target: string;
}
